import { render, staticRenderFns } from "./verify-type-confirm.vue?vue&type=template&id=6ac05293"
import script from "./verify-type-confirm.vue?vue&type=script&lang=js"
export * from "./verify-type-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports